<template>
  <qc-container v-if="detail" title="分账规则">
    <div class="flex" >
      <el-form ref="ruleForm" :model="detail" label-width="120px">
        <h3>加盟店</h3>
        <el-form-item class="row" label="出售订单" >
          <el-input-number  :controls="false" v-model.number="detail.franchiseSellRatio"/>
          <span class="ml10">%</span>
        </el-form-item>
        <h3>实体店</h3>
        <el-form-item class="row" label="出售订单" >
          <el-input-number  :controls="false" v-model.number="detail.storeSellRatio"/>
          <span class="ml10">%</span>
        </el-form-item>
        <el-form-item class="row" label="租赁订单" >
          <el-input-number  :controls="false" v-model.number="detail.storeLeaseRatio"/>
          <span class="ml10">%</span>
        </el-form-item>
        <h3>洗消店</h3>
        <el-form-item class="row" label="洗消订单" >
          <el-input-number  :controls="false" v-model.number="detail.washingRatio"/>
          <span class="ml10">%</span>
        </el-form-item>
      </el-form>
    </div>
  </qc-container>

  <qc-container class="mt20" v-if="detail" title="提现规则">
    <el-form class="mt20" ref="ruleForm" :model="detail" label-width="120px">
      <el-form-item class="row" label="手续费" >
        <el-input-number  :controls="false" v-model.number="detail.withdrawRatio"/>
        <span class="ml10">%</span>
      </el-form-item>
      <el-form-item class="row" label="最低提现金额" >
        <el-input-number  :controls="false" v-model.number="detail.minWithdrawMoney"/>
        <span class="ml10">元</span>
      </el-form-item>
    </el-form>
  </qc-container>
  <qc-container class="mt20">
    <el-form class="mt10" label-width="120px">
      <el-form-item class="tc mr50">
        <el-button class="f14 " type="primary" @click="submitForm()">保存规则</el-button>
      </el-form-item>
    </el-form>
  </qc-container>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";

export default {
  name: "set",
  components: {QcContainer},
  data() {
    return {
      detail:null,
    }
  },
  mixins: [tableBase],
  methods: {
    submitForm(){
      this.simplePost("/api/mgr/setting/addOrUpdate",this.detail,result=>{
        this.message("修改成功");
      })
    }
  },
  mounted() {
    this.simplePost("/api/mgr/setting/getDetail",null,res=>{
      this.detail = res.data;
    })
  }
}
</script>


<style lang="less" scoped>
</style>
